import {useQuery} from "@tanstack/react-query";
import {useCallback} from "react";

import {sanitizeListing} from "../../../models/listing";
import {useListingService} from "../useListingService";

export const useFetchListingID = (listingID: string | undefined) => {
    const listingService = useListingService();

    return useQuery({
        queryKey: ["/getListing/:listingID", listingID],
        queryFn: useCallback(async () => {
            if (!listingID) {
                return Promise.resolve(null);
            }
            const data = await listingService.get("/getListing/:listingID", {listingID});
            return sanitizeListing(data);
        }, [listingID, listingService])
    });
};
